import React, { useState, useEffect } from "react"
import styles from "../../styles/global.module.scss"
import { useGetAllActiveServices } from "../../hooks/useGetAllActiveServices"
import states from "../../data/states_titlecase.json"
// import validateQuote from "../../helpers/validation/quote-validation"

export default function QuotingForm({ selectedService, quote_settings }) {
  // Initialize local state
  let [localState, setLocalState] = useState({
    name: "",
    email: "",
    phone: "",
    contact_time: "",
    address_1: "",
    address_2: "",
    city: "",
    state: "",
    zip: "",
    service: "",
    type: "",
    company: "",
    details: "",
    errors: {},
  })

  // Get all services
  let all_services = useGetAllActiveServices()

  // If quote settings not available, set to empty string
  let quote_availability = "",
    quote_state = ""
  if (quote_settings) {
    quote_availability = quote_settings.Availability || ""
    quote_state = quote_settings.State || ""
  }

  // Set local service state to requested quote
  useEffect(() => {
    setLocalState({
      ...localState,
      service: selectedService,
      contact_time: quote_availability,
      state: quote_state,
    })
  }, [selectedService, quote_settings, quote_availability, quote_state]) // eslint-disable-line react-hooks/exhaustive-deps

  // Update state on form field change
  const onChange = e => {
    // let errors = validateQuote(localState)
    setLocalState({
      ...localState,
      [e.target.name]: e.target.value,
      // errors,
    })
  }

  return (
    <form
      className={`${styles.primaryForm} ${styles.quotingForm}`}
      name="Quotes"
      method="POST"
      netlify-honeypot="bot-field"
      data-netlify="true"
      action="/thanks-for-requesting-a-quote/"
    >
      <input type="hidden" name="form-name" value="Quotes" />
      <input type="hidden" name="bot-field" />
      <div className={styles.flexWrapper}>
        <div className={styles.formItem}>
          <label htmlFor="name">Name *</label>
          <input
            type="text"
            name="name"
            placeholder="Your Name"
            onBlur={e => onChange(e)}
            onChange={e => onChange(e)}
            value={localState.name || ""}
            // className={localState.errors.name ? styles.formError : ""}
            required
          />
        </div>
        <div className={styles.formItem}>
          <label htmlFor="email">Email *</label>
          <input
            type="email"
            name="email"
            placeholder="Your Email"
            onBlur={e => onChange(e)}
            onChange={e => onChange(e)}
            value={localState.email || ""}
            // className={localState.errors.email ? styles.formError : ""}
            required
          />
        </div>
      </div>
      <div className={styles.flexWrapper}>
        <div className={styles.formItem}>
          <label htmlFor="phone">Phone *</label>
          <input
            type="phone"
            name="phone"
            placeholder="Phone Number"
            onBlur={e => onChange(e)}
            onChange={e => onChange(e)}
            // className={localState.errors.phone ? styles.formError : ""}
            required
          />
        </div>
        <div className={styles.formItem}>
          <label htmlFor="contact_time">Best Time to Contact </label>
          <select
            name="contact_time"
            onBlur={e => onChange(e)}
            onChange={e => onChange(e)}
            value={localState.contact_time || "Anytime"}
          >
            <option value="Anytime">Anytime</option>
            <option value="Morning">Morning</option>
            <option value="Afternoon">Afternoon</option>
            <option value="Evening">Evening</option>
          </select>
        </div>
      </div>
      <div className={styles.flexWrapper}>
        <div className={styles.formItem}>
          <label htmlFor="address_1">Address 1 *</label>
          <input
            type="text"
            name="address_1"
            placeholder="Address 1"
            onBlur={e => onChange(e)}
            onChange={e => onChange(e)}
            // className={localState.errors.address_1 ? styles.formError : ""}
            required
          />
        </div>
        <div className={styles.formItem}>
          <label htmlFor="address_2">Address 2</label>
          <input
            type="text"
            name="address_2"
            placeholder="Address 2"
            onBlur={e => onChange(e)}
            onChange={e => onChange(e)}
          />
        </div>
      </div>
      <div id={styles.cityStateZip} className={styles.flexWrapper}>
        <div id={styles.formItemCity} className={styles.formItem}>
          <label htmlFor="city">City *</label>
          <input
            type="text"
            name="city"
            placeholder="City"
            onBlur={e => onChange(e)}
            onChange={e => onChange(e)}
            // className={localState.errors.city ? styles.formError : ""}
            required
          />
        </div>
        <div id={styles.formItemState} className={styles.formItem}>
          <label htmlFor="state">State *</label>
          <select
            name="state"
            onBlur={e => onChange(e)}
            onChange={e => onChange(e)}
            value={localState.state || "0"}
            // className={localState.errors.state ? styles.formError : ""}
            required
          >
            <option value="0" disabled>
              Select A State
            </option>
            {states
              ? states.map((state, i) => (
                  <option value={state.name} key={i}>
                    {state.name}
                  </option>
                ))
              : null}
          </select>
        </div>
        <div id={styles.formItemZip} className={styles.formItem}>
          <label htmlFor="zipcode">Zip *</label>
          <input
            type="text"
            name="zip"
            placeholder="Zip"
            onBlur={e => onChange(e)}
            onChange={e => onChange(e)}
            // className={localState.errors.zip ? styles.formError : ""}
            required
          />
        </div>
      </div>
      <div id={styles.selectedService}>
        <label htmlFor="service">Service Request</label>
        <div className={styles.flexWrapper}>
          <div className={styles.formItem}>
            <select
              name="service"
              onBlur={e => onChange(e)}
              onChange={e => onChange(e)}
              value={localState.service}
            >
              <option value="0">Select A Service</option>
              {all_services
                ? all_services.map((service, i) => (
                    <option value={service.node.frontmatter.name} key={i}>
                      {service.node.frontmatter.name}
                    </option>
                  ))
                : null}
            </select>
          </div>
          <div className={styles.formItem}>
            <div id={styles.quoteType} className={styles.flexWrapper}>
              <label htmlFor="quote-radios">Type of job:</label>
              <div
                id="quote-radios"
                className={`${styles.formItem} ${styles.flexWrapper}`}
              >
                <label htmlFor="quote_type_residential">
                  Residential
                  <input
                    id="quote_type_residential"
                    defaultChecked
                    type="radio"
                    name="type"
                    onBlur={e => onChange(e)}
                    onChange={e => onChange(e)}
                    value="residential"
                  />
                </label>
              </div>
              <div
                id="quote-radios"
                className={`${styles.formItem} ${styles.flexWrapper}`}
              >
                <label htmlFor="quote_type_commercial">
                  Commercial
                  <input
                    id="quote_type_commercial"
                    type="radio"
                    name="type"
                    onBlur={e => onChange(e)}
                    onChange={e => onChange(e)}
                    value="commercial"
                  />
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
      {localState.type === "commercial" ? (
        <div className={styles.formItem}>
          <label htmlFor="company">Company </label>
          <input
            type="text"
            name="company"
            placeholder="Company or Organization"
            onBlur={e => onChange(e)}
            onChange={e => onChange(e)}
          />
        </div>
      ) : (
        false
      )}
      <div className={styles.formItem}>
        <label htmlFor="details">Job Details *</label>
        <textarea
          name="details"
          placeholder="List the job details here"
          rows="4"
          cols="50"
          onBlur={e => onChange(e)}
          onChange={e => onChange(e)}
          // className={localState.errors.details ? styles.formError : ""}
          required
        />
      </div>
      <div className={styles.buttonContain}>
        <button className={styles.btn} type="submit" aria-label="Submit">
          Submit
        </button>
      </div>
    </form>
  )
}
